import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { addTags, closeAddressDialog, editTags } from 'reducers/DialogsReducer';
import { showDisplayDataWindow } from 'reducers/DialogsReducer';
import { handleError } from 'reducers/ErrorReducer';
import { XGrid } from '@material-ui/x-grid';
import Tooltip from 'components/Tooltip';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { notify } from 'reducers/NotifierReducer';
import EditIcon from '@material-ui/icons/Edit';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import { getService } from 'reducers/service';

const columns = [
  { field: 'label', headerName: 'Label', flex: 1 },
  { field: 'value', headerName: 'Value', flex: 1 },
];

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  wrapDialog: {
    width: '100%',
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 300,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '0 4px 8px',
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  actionsDialog: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 4px 8px',
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  tagTitle: {
    fontSize: '1rem',
  },
}));

function TagsTab(props) {
  const { ptsEventID, dataUpdate, disableEdit, parentType } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [selection, setSelection] = useState(null);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const perms = getFullPermissions('cad', 'Events', 'any');
  const isUnitFromStatus = parentType === 'CAD Unit Status';

  useEffect(() => {
    getTags();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!dataUpdate || dataUpdate.type !== 'Tags') return;
    getTags();
    //eslint-disable-next-line
  }, [dataUpdate]);

  const getTags = async () => {
    try {
      const service = await getService('ptstags');
      const tagData = await service.find({
        query: {
          ParentType: parentType,
          ptsParentID: ptsEventID,
          IsDeleted: false,
          $limit: 0,
        },
      });
      const tags =
        tagData?.data?.map((tag) => ({
          id: tag?.ptsTagID,
          label: tag?.Type,
          value: tag?.Value,
        })) || [];
      setData(tags);
      setLoaded(true);
    } catch (err) {
      props.handleError(err, 'Error receiving tags data.');
    }
  };

  const add = () => props.addTags({ type: 'event', ptsEventID, parentType: parentType, getTags });
  const edit = () => {
    props.editTags({ ptsTagID: selection, ptsEventID, parentType: parentType, getTags });
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete selected tag?')) return;
    try {
      const service = await getService('ptstags');
      await service.remove(selection);
      await getTags();
      dispatch(notify('Tag updated successfully', 'success'));
    } catch (err) {
      props.handleError(err, 'Error, Unable to remove Tag');
    }
  };

  return (
    <div className={isUnitFromStatus ? classes.wrapDialog : classes.wrap}>
      {!disableEdit && (
        <div className={isUnitFromStatus ? classes.actionsDialog : ''}>
          {isUnitFromStatus && <span className={classes.tagTitle}>Tags</span>}
          <div className={classes.actions}>
            <Tooltip title="Add Tag">
              <Fab size="small" color="secondary" onClick={add} disabled={!perms.Edit}>
                <AddIcon fontSize="small" />
              </Fab>
            </Tooltip>
            {selection !== null && (
              <>
                <Tooltip title="Edit Bulletin">
                  <Fab onClick={edit} size="small" color="secondary" disabled={!perms.Edit}>
                    <EditIcon />
                  </Fab>
                </Tooltip>
                <Tooltip title="Delete SOP">
                  <Fab size="small" color="secondary" onClick={handleDelete} disabled={!perms.Edit}>
                    <DeleteIcon />
                  </Fab>
                </Tooltip>
              </>
            )}
          </div>
        </div>
      )}

      <div className={classes.gridWrap}>
        <XGrid
          columns={columns}
          rows={data}
          loading={!loaded}
          disableMultipleSelection={true}
          disableColumnFilter
          density={'compact'}
          disableColumnMenu
          hideFooter
          onSelectionModelChange={(newSelection) => {
            setSelection(newSelection.selectionModel[0]);
          }}
          onColumnVisibilityChange={(col) => setHiddenColumns([...hiddenColumns, col.field])}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    addAddressSOP: state.dialogs.addAddressSOP,
    dataUpdate: state.dataUpdate,
  };
};

export default connect(mapStateToProps, {
  closeAddressDialog,
  handleError,
  showDisplayDataWindow,
  addTags,
  notify,
  editTags,
})(TagsTab);
